var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thiết lập điểm danh",
        visible: _vm.dialogVisible,
        width: "1300px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "2vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.systemConfigSchoolData != null
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "wrapper-table",
            },
            [
              _c(
                "el-table",
                {
                  staticClass: "sk-table custom-attendance-table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.configRows,
                    border: "",
                    "max-height": _vm.$tableMaxHeight,
                    loading: _vm.loading,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "STT",
                      width: "55",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Nội dung thiết lập", "min-width": "500" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "wrapper-config-label" },
                                [
                                  _c("span", { staticClass: "config-desc" }, [
                                    _vm._v(_vm._s(row.description)),
                                  ]),
                                  row.tooltip != null
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: row.tooltip,
                                            placement: "top",
                                            "open-delay": 300,
                                            effect: "dark",
                                            "popper-class":
                                              "config-tooltip-popper",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: { color: "#6a96d6" },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      889059176
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thiết lập",
                      width: "380",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.type === "boolean"
                                ? [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { disabled: row.disabled },
                                        model: {
                                          value: _vm.getObj(row)[row.field],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.getObj(row),
                                              row.field,
                                              $$v
                                            )
                                          },
                                          expression: "getObj(row)[row.field]",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: { label: !row.invertLabel },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(row.labelTrue || "Có")
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: { label: !!row.invertLabel },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(row.labelFalse || "Không")
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : row.type === "time"
                                ? [
                                    _c("el-time-picker", {
                                      staticStyle: { width: "280px" },
                                      attrs: {
                                        size: "mini",
                                        clearable: false,
                                        "value-format": "HH:mm",
                                        format: "HH:mm",
                                        disabled: row.disabled,
                                        "picker-options": {
                                          selectableRange:
                                            "00:00:00 - 23:59:59",
                                        },
                                        placeholder: "Chọn",
                                      },
                                      model: {
                                        value: _vm.getObj(row)[row.field],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.getObj(row),
                                            row.field,
                                            $$v
                                          )
                                        },
                                        expression: "getObj(row)[row.field]",
                                      },
                                    }),
                                  ]
                                : row.type === "input"
                                ? [
                                    _c("el-input", {
                                      staticStyle: { width: "280px" },
                                      attrs: {
                                        size: "mini",
                                        disabled: row.disabled,
                                        placeholder: row.placeholder || "Nhập",
                                        maxlength: row.maxlength,
                                      },
                                      model: {
                                        value: _vm.getObj(row)[row.field],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.getObj(row),
                                            row.field,
                                            $$v
                                          )
                                        },
                                        expression: "getObj(row)[row.field]",
                                      },
                                    }),
                                  ]
                                : row.type === "number"
                                ? [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "mini",
                                        disabled: row.computedDisabled
                                          ? row.computedDisabled(
                                              _vm.systemConfigSchoolData
                                            )
                                          : row.disabled,
                                        min: row.min,
                                        max: row.max,
                                        step: row.step || 1,
                                      },
                                      model: {
                                        value: _vm.getObj(row)[row.field],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.getObj(row),
                                            row.field,
                                            $$v
                                          )
                                        },
                                        expression: "getObj(row)[row.field]",
                                      },
                                    }),
                                    row.suffix
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.suffix))]
                                        )
                                      : _vm._e(),
                                  ]
                                : row.type === "select"
                                ? [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "250px" },
                                        attrs: {
                                          disabled: row.disabled,
                                          placeholder:
                                            row.placeholder || "Chọn",
                                        },
                                        model: {
                                          value: _vm.getObj(row)[row.field],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.getObj(row),
                                              row.field,
                                              $$v
                                            )
                                          },
                                          expression: "getObj(row)[row.field]",
                                        },
                                      },
                                      _vm._l(row.options, function (opt) {
                                        return _c("el-option", {
                                          key: opt.value,
                                          attrs: {
                                            value: opt.value,
                                            label: opt.label,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ]
                                : row.type === "checkbox-group"
                                ? _vm._l(row.checkboxes, function (cb) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: cb.field,
                                        attrs: { disabled: row.disabled },
                                        model: {
                                          value: _vm.getObj(row)[cb.field],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.getObj(row),
                                              cb.field,
                                              $$v
                                            )
                                          },
                                          expression: "getObj(row)[cb.field]",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(cb.label) + "\n            "
                                        ),
                                      ]
                                    )
                                  })
                                : row.type === "switch-group"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "switch-group" },
                                      _vm._l(
                                        row.switches,
                                        function (item, idx) {
                                          return _c(
                                            "div",
                                            {
                                              key: idx,
                                              staticClass: "switch-item",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.label)),
                                              ]),
                                              _c("el-switch", {
                                                attrs: {
                                                  disabled: row.disabled,
                                                },
                                                model: {
                                                  value:
                                                    _vm.getObj(row)[item.field],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.getObj(row),
                                                      item.field,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "getObj(row)[item.field]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                : row.type === "multi-boolean"
                                ? _vm._l(row.subFields, function (sub, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: idx,
                                        staticClass: "multi-boolean-row",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "multi-boolean-label",
                                          },
                                          [_vm._v(_vm._s(sub.label))]
                                        ),
                                        _c(
                                          "el-radio-group",
                                          {
                                            attrs: { disabled: row.disabled },
                                            model: {
                                              value: _vm.getObj(row)[sub.field],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.getObj(row),
                                                  sub.field,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "getObj(row)[sub.field]",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: true } },
                                              [_vm._v("Có")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: false } },
                                              [_vm._v("Không")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  })
                                : row.type === "input-time"
                                ? [
                                    _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "280px" },
                                          attrs: {
                                            size: "mini",
                                            placeholder:
                                              row.placeholder || "Nhập số ngày",
                                          },
                                          model: {
                                            value: _vm.getObj(row)[row.field],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.getObj(row),
                                                row.field,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "getObj(row)[row.field]",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      [
                                        _c("el-time-picker", {
                                          staticStyle: { width: "280px" },
                                          attrs: {
                                            size: "mini",
                                            clearable: false,
                                            "value-format": "HH:mm",
                                            format: "HH:mm",
                                            "picker-options": {
                                              selectableRange:
                                                "00:00:00 - 23:59:59",
                                            },
                                            placeholder: "Chọn",
                                          },
                                          model: {
                                            value:
                                              _vm.getObj(row)[row.timeField],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.getObj(row),
                                                row.timeField,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "getObj(row)[row.timeField]",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : row.type === "late-pickup"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "composite-config" },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value:
                                                _vm.schoolConfig.statusBlock,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.schoolConfig,
                                                  "statusBlock",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "schoolConfig.statusBlock",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: true } },
                                              [_vm._v("Block")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: false } },
                                              [_vm._v("Ngày")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px",
                                            },
                                          },
                                          [
                                            _c("span", [_vm._v("Số phút: ")]),
                                            _c("el-input-number", {
                                              staticStyle: { width: "160px" },
                                              attrs: {
                                                min: 0,
                                                step: 1,
                                                size: "mini",
                                              },
                                              model: {
                                                value:
                                                  _vm.schoolConfig
                                                    .blockLeaveKid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.schoolConfig,
                                                    "blockLeaveKid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "schoolConfig.blockLeaveKid",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-radio-group",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px",
                                            },
                                            model: {
                                              value:
                                                _vm.schoolConfig.statusUpDown,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.schoolConfig,
                                                  "statusUpDown",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "schoolConfig.statusUpDown",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: true } },
                                              [_vm._v("Làm tròn lên")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: false } },
                                              [_vm._v("Làm tròn xuống")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : row.type === "home-tab-order"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "home-tab-config" },
                                      [
                                        _c(
                                          "table",
                                          { staticClass: "tab-order-table" },
                                          [
                                            _c(
                                              "tr",
                                              _vm._l(
                                                _vm.homeTabItems,
                                                function (tab) {
                                                  return _c(
                                                    "td",
                                                    { key: tab.field },
                                                    [_vm._v(_vm._s(tab.label))]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "tr",
                                              _vm._l(
                                                _vm.homeTabItems,
                                                function (tab) {
                                                  return _c(
                                                    "td",
                                                    { key: "cb-" + tab.field },
                                                    [
                                                      _c("el-checkbox", {
                                                        attrs: {
                                                          disabled:
                                                            tab.activeField ===
                                                            "activeShowNews",
                                                        },
                                                        on: {
                                                          change: (v) =>
                                                            _vm.handleTabActiveChange(
                                                              tab,
                                                              v
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.schoolConfig[
                                                              tab.activeField
                                                            ],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.schoolConfig,
                                                              tab.activeField,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "schoolConfig[tab.activeField]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "tr",
                                              _vm._l(
                                                _vm.homeTabItems,
                                                function (tab) {
                                                  return _c(
                                                    "td",
                                                    { key: "sel-" + tab.field },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "55px",
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                            disabled:
                                                              !_vm.schoolConfig[
                                                                tab.activeField
                                                              ],
                                                          },
                                                          on: {
                                                            change: (v) =>
                                                              _vm.handleTabOrderChange(
                                                                tab,
                                                                v
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.schoolConfig[
                                                                tab.sttField
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.schoolConfig,
                                                                tab.sttField,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "schoolConfig[tab.sttField]",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.activeTabCount,
                                                          function (n) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: n,
                                                                attrs: {
                                                                  value: n,
                                                                  label:
                                                                    String(n),
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : row.type === "tuition-plus"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "composite-config" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm._v(
                                              "Gửi thông báo hoá đơn mới?\n                "
                                            ),
                                            _c(
                                              "el-radio-group",
                                              {
                                                staticStyle: {
                                                  "margin-left": "8px",
                                                },
                                                model: {
                                                  value:
                                                    _vm.schoolConfig
                                                      .statusOrderNew,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.schoolConfig,
                                                      "statusOrderNew",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "schoolConfig.statusOrderNew",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: true } },
                                                  [_vm._v("Có")]
                                                ),
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: false } },
                                                  [_vm._v("Không")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "8px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Ngày bắt đầu:\n                "
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100px" },
                                              attrs: { size: "small" },
                                              model: {
                                                value:
                                                  _vm.schoolConfig.dateSendPlus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.schoolConfig,
                                                    "dateSendPlus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "schoolConfig.dateSendPlus",
                                              },
                                            }),
                                            _vm.schoolConfig.sendRepeatPlus &&
                                            !_vm.schoolConfig.statusOrderNew
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Bước nhảy: "
                                                    ),
                                                    _c("el-input-number", {
                                                      staticStyle: {
                                                        width: "100px",
                                                      },
                                                      attrs: { size: "small" },
                                                      model: {
                                                        value:
                                                          _vm.schoolConfig
                                                            .dateJumpPlus,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.schoolConfig,
                                                            "dateJumpPlus",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "schoolConfig.dateJumpPlus",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        !_vm.schoolConfig.statusOrderNew
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-top": "8px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Gửi lặp lại?\n                "
                                                ),
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "8px",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.schoolConfig
                                                          .sendRepeatPlus,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.schoolConfig,
                                                          "sendRepeatPlus",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "schoolConfig.sendRepeatPlus",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true },
                                                      },
                                                      [_vm._v("Có")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false },
                                                      },
                                                      [_vm._v("Không")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "8px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Hết hạn trước:\n                "
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100px" },
                                              attrs: { size: "small" },
                                              model: {
                                                value:
                                                  _vm.schoolConfig.datePlus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.schoolConfig,
                                                    "datePlus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "schoolConfig.datePlus",
                                              },
                                            }),
                                            _vm._v(
                                              "\n                Ngày\n              "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                : row.type === "tuition-parent"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "composite-config" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm._v(
                                              "Ngày bắt đầu:\n                "
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100px" },
                                              attrs: { size: "small" },
                                              model: {
                                                value:
                                                  _vm.schoolConfig
                                                    .dateSendParent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.schoolConfig,
                                                    "dateSendParent",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "schoolConfig.dateSendParent",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "8px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Bước nhảy:\n                "
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100px" },
                                              attrs: { size: "small" },
                                              model: {
                                                value:
                                                  _vm.schoolConfig
                                                    .dateJumpParent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.schoolConfig,
                                                    "dateJumpParent",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "schoolConfig.dateJumpParent",
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                              },
                                              [
                                                _vm._v("Tần suất: "),
                                                _c("el-input-number", {
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                  attrs: { size: "small" },
                                                  model: {
                                                    value:
                                                      _vm.schoolConfig
                                                        .dateFrequencyParent,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.schoolConfig,
                                                        "dateFrequencyParent",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "schoolConfig.dateFrequencyParent",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "8px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Hết hạn trước:\n                "
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100px" },
                                              attrs: { size: "small" },
                                              model: {
                                                value:
                                                  _vm.schoolConfig.dateParent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.schoolConfig,
                                                    "dateParent",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "schoolConfig.dateParent",
                                              },
                                            }),
                                            _vm._v(
                                              "\n                Ngày\n              "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      872047746
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "40px 0",
                color: "#909399",
              },
            },
            [_vm._v("Không có dữ liệu")]
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: { click: _vm.closeDialog },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
              },
              on: { click: _vm.submitForm },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }